module.exports = __webpack_public_path__ + "static/kwfitness_logo-36230d348784a42e83d9ce69719cba40.png";